import { getAdminAxiosInstance } from "../../../api/Admin";

export const updateFavourite = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/favourite-category-icon/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const viewFavourite = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/favourite-category-icon/edit?id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getFavouriteCategoryImage = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(
      `/favourite-category-icon/upload-image`,
      params
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
